// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3tD_D","column":"style_column__3JXWi","row":"style_row__2FIzH"};